
import {takeUntil} from 'rxjs/operators';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {CollectionOptionsInterface} from 'octopus-connect';
import {DatacardService} from 'shared/datacard.service';
import {ThemesService} from '@modules/activities/core/themes/themes.service';
import {OrderDirection} from 'octopus-connect';
import {Subject} from 'rxjs';
import {LessonsService} from '@modules/activities/core/lessons/services/lessons.service';

@Component({
    selector: 'app-theme-created',
    templateUrl: './theme-created.component.html',
    styleUrls: ['./theme-created.component.scss']
})
export class ThemeCreatedComponent implements OnInit, OnDestroy {
    public dataCards: any[] = [];

    private optionsInterface: CollectionOptionsInterface;
    private unsubscribeInTakeUntil = new Subject<void>();

    constructor(
        private datacardService: DatacardService,
        private themesService: ThemesService,
        private lessonsService: LessonsService,
    ) {
        this.optionsInterface = {
            orderOptions: [
                {field: 'created', direction: OrderDirection.DESC}
            ],
            page: 1,
            range: 6
        };
    }

    ngOnInit() {
        const callbacks = {
            'downloadDoc': (resource) => this.datacardService.downloadDoc(resource),
            'play': (resource) => this.lessonsService.loadAndNavigateToLessonFromAssignment(resource)
        };

        this.themesService.getThemes(this.optionsInterface).pipe(
            takeUntil(this.unsubscribeInTakeUntil))
            .subscribe((themes) => {
                    this.dataCards = this.datacardService.processResources(themes, callbacks, 'themes');
                },
                (err) => console.log(err));
    }

    ngOnDestroy(): void {
        this.unsubscribeInTakeUntil.next();
        this.unsubscribeInTakeUntil.complete();
    }
}
